module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIxNCIgeT0iMTEiIHdpZHRoPSIxMyIgaGVpZ2h0PSIyMSI+CjxwYXRoIGQ9Ik0xNC4zMTY0IDI4LjlMMjEuOTQ5NyAyMS4yNUwxNC4zMTY0IDEzLjZMMTYuNjY2NCAxMS4yNUwyNi42NjY0IDIxLjI1TDE2LjY2NjQgMzEuMjVMMTQuMzE2NCAyOC45WiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0iIzYwMzk3NSIvPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-arrow.svg
// module id = 7naG
// module chunks = 37